import Markdown from "react-native-markdown-display";
import { Button, Card, QuestionMarkIcon } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Popover, YStack } from "tamagui";

export const HowToReadTooltip = () => {
  const { t } = useTranslation("slices");
  return (
    <Popover placement="bottom-end">
      <Popover.Trigger>
        <Button
          data-id="involvement-dynamics-chart-how-to-read"
          variant="outlined"
          size="sm"
          rounded="lg"
          iconAfter={<QuestionMarkIcon />}
        >
          {t(
            "results.linear-chart-by-scale-and-survey-type.how-to-read-tooltip.trigger",
          )}
        </Button>
      </Popover.Trigger>

      <Popover.Content padding={0} y={"$1"}>
        <Card maxWidth={400} paddingHorizontal={"$3"}>
          <YStack gap={"$2"}>
            <Markdown
              style={{
                body: {
                  fontFamily: "Fixel Text",
                  fontSize: 16,
                  lineHeight: 20,
                  color: "#111111",
                },
              }}
            >
              {t(
                "results.linear-chart-by-scale-and-survey-type.how-to-read-tooltip.content",
              )}
            </Markdown>
          </YStack>
        </Card>
      </Popover.Content>
    </Popover>
  );
};
